<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ purchasesQty }} {{ $tc("purchases.productsCosts", purchasesQty) }}&nbsp;

    <button class="button" @click="$emit('get-purchases')">
      <b-icon icon="sync-alt"></b-icon>
    </button>
    &nbsp;

    <button
      class="button"
      @click="downloadPurchasesReport"
      v-if="permissions.downloadPurchasesReport"
    >
      <b-icon icon="save"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["purchasesQty"],

  mixins: [common],

  components: {
    goToDashboardButton
  },

  methods: {
    downloadPurchasesReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadPurchasesReport")
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["ownerInfo", "locale", "stores", "lockers", "permissions"])
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
